module.exports = __webpack_public_path__ + "img/gb13871-92_25x47x7.prt.69fe9a1f.jpg";